import { SimulatedUpdate } from "@/features/private-room/bookings/context/use-po-contracts-update-flow/use-po-contracts-update-flow.types";
import { apiWobaBackend } from "@/services/api-woba-backend";
import { useState } from "react";
import {
  PreviewContractUpdateResponse,
  SimulateUpdateProps,
} from "./use-po-contracts-update-preview.types";

export const usePoContractsUpdatePreview = () => {
  const [simulatedUpdate, setSimulatedUpdate] = useState<SimulatedUpdate>({
    toCreate: {
      count: 0,
      hasProRata: false,
    },
    toUpdate: {
      count: 0,
    },
    toCancel: {
      count: 0,
    },
  });

  const simulateUpdate = async ({
    contractId,
    alteredFields,
  }: SimulateUpdateProps) => {
    const response: PreviewContractUpdateResponse = await apiWobaBackend.post(
      `/private-offices/contracts/${contractId}/preview`,
      alteredFields,
    );

    setSimulatedUpdate(response.data);
  };

  return {
    simulatedUpdate,
    simulateUpdate,
  };
};
